export const DropTypes = {
  STAMP: 'stamp',
}

export interface Stamp {
  id: string
  fileId: number
  x: number
  y: number
  width: number
  height: number
  page: Page
  signer: Signer
}

interface Signer {
  id: number
  fullName: string
  avatar: string
  jobTitle: string
}

interface Page {
  number: number
  width: number
  height: number
}

export interface DragStamp {
  signerId: number
}

// README: Status legend
// - Default: initial state of the stamp in the sidebar
// - Hover: when the user hovers over the stamp
// - Editable: when the stamp is placed in the page (and the customization options are shown)
// - Error: when the stamp is not placed and the form has been submitted
// - Success: when the stamp is placed and the form has been submitted
export type StampStatus = 'default' | 'hover' | 'editable' | 'error' | 'success'

export const DEFAULT_PAGE_WIDTH_MARGIN = 12
export const DEFAULT_PAGE_HEIGHT_MARGIN = 12

export const DEFAULT_WIDTH_SIGNER_STAMP = 160
export const DEFAULT_HEIGHT_SIGNER_STAMP = 75

export const MIN_WIDTH_SIGNER_STAMP = 100
export const MIN_HEIGHT_SIGNER_STAMP = 50
